import { Dialog, DialogClose, DialogTitle } from "@suse-o11y/dialog";
import { IconClose } from "@suse-o11y/icons";
import React, { type FC } from "react";

import { AddToDashboardContent, type AddToDashboardContentProps } from "./_add-to-dashboard-content";

export type AddToDashboardDrawerProps = AddToDashboardContentProps;

export const AddToDashboardDrawer: FC<AddToDashboardDrawerProps> = ({ widgets }) => (
	<Dialog className="drawer/dialog drawer-narrow" data-beest-testid="add-to-dashboard-drawer">
		<header className="drawer-header">
			<DialogTitle className="drawer-title">Add to dashboard...</DialogTitle>

			<DialogClose aria-label="Close" className="button button-square ml-auto">
				<IconClose className="size-3" />
			</DialogClose>
		</header>

		<section className="drawer-body">
			<AddToDashboardContent widgets={widgets} />
		</section>
	</Dialog>
);
